import { render, staticRenderFns } from "./ResourceGeneralTab.vue?vue&type=template&id=39c340c8&lang=pug&"
import script from "./ResourceGeneralTab.vue?vue&type=script&lang=js&"
export * from "./ResourceGeneralTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports